"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTokenAccountInstructions = exports.combineIxsForTx = exports.BNtoBigInt = exports.bigIntToBN = exports.getUnderlyingToKeyMapping = exports.getUnderlyingMapping = exports.getTokenAccountsForMint = exports.createWrappedNativeAccount = exports.processTransaction = exports.getClockTimestamp = exports.readBigInt64LE = exports.boundsError = exports.validateNumber = exports.ERR_OUT_OF_RANGE = exports.ERR_INVALID_ARG_TYPE = exports.ERR_BUFFER_OUT_OF_BOUNDS = exports.defaultCommitment = exports.sleep = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const buffer_layout_1 = __importDefault(require("buffer-layout"));
const program_1 = require("./program");
const errors_1 = require("./errors");
const constants_1 = require("./constants");
async function sleep(ms) {
    await new Promise((resolve) => setTimeout(resolve, ms, undefined));
}
exports.sleep = sleep;
function defaultCommitment() {
    return {
        skipPreflight: false,
        preflightCommitment: "processed",
        commitment: "processed",
    };
}
exports.defaultCommitment = defaultCommitment;
const uint64 = (property = "uint64") => {
    return buffer_layout_1.default.blob(8, property);
};
const int64 = (property = "int64") => {
    return buffer_layout_1.default.blob(8, property);
};
// https://github.com/nodejs/node/blob/v14.17.0/lib/internal/errors.js#L758
const ERR_BUFFER_OUT_OF_BOUNDS = () => new Error("Attempt to access memory outside buffer bounds");
exports.ERR_BUFFER_OUT_OF_BOUNDS = ERR_BUFFER_OUT_OF_BOUNDS;
// https://github.com/nodejs/node/blob/v14.17.0/lib/internal/errors.js#L968
const ERR_INVALID_ARG_TYPE = (name, expected, actual) => new Error(`The "${name}" argument must be of type ${expected}. Received ${actual}`);
exports.ERR_INVALID_ARG_TYPE = ERR_INVALID_ARG_TYPE;
// https://github.com/nodejs/node/blob/v14.17.0/lib/internal/errors.js#L1262
const ERR_OUT_OF_RANGE = (str, range, received) => new Error(`The value of "${str} is out of range. It must be ${range}. Received ${received}`);
exports.ERR_OUT_OF_RANGE = ERR_OUT_OF_RANGE;
// https://github.com/nodejs/node/blob/v14.17.0/lib/internal/validators.js#L127-L130
function validateNumber(value, name) {
    if (typeof value !== "number")
        throw (0, exports.ERR_INVALID_ARG_TYPE)(name, "number", value);
}
exports.validateNumber = validateNumber;
// https://github.com/nodejs/node/blob/v14.17.0/lib/internal/buffer.js#L68-L80
function boundsError(value, length) {
    if (Math.floor(value) !== value) {
        validateNumber(value, "offset");
        throw (0, exports.ERR_OUT_OF_RANGE)("offset", "an integer", value);
    }
    if (length < 0)
        throw (0, exports.ERR_BUFFER_OUT_OF_BOUNDS)();
    throw (0, exports.ERR_OUT_OF_RANGE)("offset", `>= 0 and <= ${length}`, value);
}
exports.boundsError = boundsError;
function readBigInt64LE(buffer, offset = 0) {
    validateNumber(offset, "offset");
    const first = buffer[offset];
    const last = buffer[offset + 7];
    if (first === undefined || last === undefined)
        boundsError(offset, buffer.length - 8);
    const val = buffer[offset + 4] +
        buffer[offset + 5] * 2 ** 8 +
        buffer[offset + 6] * 2 ** 16 +
        (last << 24); // Overflow
    return ((BigInt(val) << BigInt(32)) +
        BigInt(first +
            buffer[++offset] * 2 ** 8 +
            buffer[++offset] * 2 ** 16 +
            buffer[++offset] * 2 ** 24));
}
exports.readBigInt64LE = readBigInt64LE;
const SystemClockLayout = buffer_layout_1.default.struct([
    uint64("slot"),
    int64("epochStartTimestamp"),
    uint64("epoch"),
    uint64("leaderScheduleEpoch"),
    int64("unixTimestamp"),
]);
function getClockTimestamp(accountInfo) {
    let info = SystemClockLayout.decode(accountInfo.data);
    return Number(readBigInt64LE(info.unixTimestamp, 0));
}
exports.getClockTimestamp = getClockTimestamp;
async function processTransaction(program, provider, tx, signers, opts) {
    const blockhash = await provider.connection.getLatestBlockhash();
    tx.recentBlockhash = blockhash.blockhash;
    tx.feePayer = provider.wallet.publicKey;
    tx = await provider.wallet.signTransaction(tx);
    if (signers === undefined) {
        signers = [];
    }
    signers
        .filter((s) => s !== undefined)
        .forEach((kp) => {
        tx.partialSign(kp);
    });
    try {
        let txSig = await (0, web3_js_1.sendAndConfirmRawTransaction)(provider.connection, tx.serialize(), opts || defaultCommitment());
        return txSig;
    }
    catch (err) {
        let translatedErr = anchor.ProgramError.parse(err, program == program_1.Program.FLEX ? errors_1.flexIdlErrors : errors_1.vaultIdlErrors);
        if (translatedErr !== null) {
            throw translatedErr;
        }
        throw err;
    }
}
exports.processTransaction = processTransaction;
async function createWrappedNativeAccount(connection, owner, payer, amount) {
    // Allocate memory for the account
    const balanceNeeded = await (0, spl_token_1.getMinimumBalanceForRentExemptAccount)(connection);
    // Create a new account
    const newAccount = web3_js_1.Keypair.generate();
    const transaction = new web3_js_1.Transaction();
    transaction.add(web3_js_1.SystemProgram.createAccount({
        fromPubkey: payer,
        newAccountPubkey: newAccount.publicKey,
        lamports: balanceNeeded,
        space: spl_token_1.AccountLayout.span,
        programId: spl_token_1.TOKEN_PROGRAM_ID,
    }));
    // Send lamports to it (these will be wrapped into native tokens by the token program)
    transaction.add(web3_js_1.SystemProgram.transfer({
        fromPubkey: payer,
        toPubkey: newAccount.publicKey,
        lamports: amount,
    }));
    // Assign the new account to the native token mint.
    // the account will be initialized with a balance equal to the native token balance.
    // (i.e. amount)
    transaction.add((0, spl_token_1.createInitializeAccountInstruction)(newAccount.publicKey, constants_1.SOL_PUBKEY, owner));
    // Send the three instructions
    return [transaction, newAccount];
}
exports.createWrappedNativeAccount = createWrappedNativeAccount;
async function getTokenAccountsForMint(connection, mint) {
    const accounts = await connection.getParsedProgramAccounts(spl_token_1.TOKEN_PROGRAM_ID, {
        filters: [
            {
                dataSize: 165, // number of bytes
            },
            {
                memcmp: {
                    offset: 0,
                    bytes: mint.toBase58(), // base58 encoded string
                },
            },
        ],
    });
    return accounts.map((acc) => {
        return {
            mint: new web3_js_1.PublicKey(acc.account.data["parsed"].info.mint),
            owner: new web3_js_1.PublicKey(acc.account.data["parsed"].info.owner),
            amount: new anchor.BN(acc.account.data["parsed"].info.tokenAmount.amount),
            decimals: acc.account.data["parsed"].info.tokenAmount.decimals,
        };
    });
}
exports.getTokenAccountsForMint = getTokenAccountsForMint;
function getUnderlyingMapping(network, tokenAddress) {
    let underlying = constants_1.PUBKEY_TO_UNDERLYINGS_MAP[network][tokenAddress.toString()];
    return underlying != undefined ? underlying : tokenAddress.toString();
}
exports.getUnderlyingMapping = getUnderlyingMapping;
function getUnderlyingToKeyMapping(network, underlyingString) {
    let pubkey = constants_1.UNDERLYINGS_TO_PUBKEY_MAP[network][underlyingString];
    if (pubkey == undefined) {
        throw Error("Underlying does not exist in constants");
    }
    return new web3_js_1.PublicKey(pubkey);
}
exports.getUnderlyingToKeyMapping = getUnderlyingToKeyMapping;
function bigIntToBN(bigInt) {
    return new anchor.BN(bigInt.toString());
}
exports.bigIntToBN = bigIntToBN;
function BNtoBigInt(bn) {
    return BigInt(bn.toString());
}
exports.BNtoBigInt = BNtoBigInt;
function combineIxsForTx(...ixs) {
    let tx = new web3_js_1.Transaction();
    tx.add(...ixs.reduce((acc, v) => acc.concat(v), []));
    return tx;
}
exports.combineIxsForTx = combineIxsForTx;
async function createTokenAccountInstructions(connection, mint, owner, payer, amount, closeNative) {
    let preIxs = [];
    let postIxs = [];
    let wrappedAccKeypair = undefined;
    let userTokenAddress = undefined;
    if (mint.equals(constants_1.SOL_PUBKEY)) {
        console.log("Mint is native wrapped SOL.");
        let [_tx, _keypair] = await createWrappedNativeAccount(connection, owner, payer, amount);
        preIxs.push(..._tx.instructions);
        wrappedAccKeypair = _keypair;
        userTokenAddress = _keypair.publicKey;
        if (closeNative) {
            postIxs.push((0, spl_token_1.createCloseAccountInstruction)(userTokenAddress, payer, owner));
        }
    }
    else {
        userTokenAddress = await (0, spl_token_1.getAssociatedTokenAddress)(mint, owner);
        try {
            await (0, spl_token_1.getAccount)(connection, userTokenAddress);
        }
        catch (e) {
            preIxs.push((0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, userTokenAddress, owner, mint));
        }
    }
    return [preIxs, postIxs, wrappedAccKeypair, userTokenAddress];
}
exports.createTokenAccountInstructions = createTokenAccountInstructions;
